import styled from 'styled-components';

export const ChecklistGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-wrap: wrap;
`;
